import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import axios from 'axios';
import { HttpError, InternalError } from "../utils/errors/index.js";
var urlPattern = 'https://{GAME_SLUG}.gslb.sbs.softgames.de'; // eslint-disable-next-line @typescript-eslint/require-await

function createRequest(gameSlug, signature, endpointOverride) {
  var url = urlPattern.replace('{GAME_SLUG}', gameSlug);
  var baseHeader = {
    authorization: "Bearer ".concat(signature)
  };
  var client = axios.create({
    baseURL: endpointOverride || url,
    timeout: 120000,
    withCredentials: true
  });
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var method, path, body, params, headers, _yield$client$request, data, _ref3, message, response, request, name, _ref4, _ref4$status, status, _ref4$data, _data, _ref5, _ref5$message, serverMessage, serverErrorCode, serverErrorId, serverTimestamp, _ref6, _ref6$responseURL, targetUrl;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              method = _ref.method, path = _ref.path, body = _ref.body, params = _ref.params, headers = _ref.headers;
              _context.prev = 1;
              _context.next = 4;
              return client.request({
                method: method,
                url: path,
                data: body,
                params: params,
                headers: _objectSpread(_objectSpread({}, headers || {}), baseHeader)
              });

            case 4:
              _yield$client$request = _context.sent;
              data = _yield$client$request.data;
              return _context.abrupt("return", data);

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](1);
              _ref3 = _context.t0, message = _ref3.message, response = _ref3.response, request = _ref3.request, name = _ref3.name;

              if (!response) {
                _context.next = 19;
                break;
              }

              _ref4 = response, _ref4$status = _ref4.status, status = _ref4$status === void 0 ? 666 : _ref4$status, _ref4$data = _ref4.data, _data = _ref4$data === void 0 ? {} : _ref4$data;
              _ref5 = _data, _ref5$message = _ref5.message, serverMessage = _ref5$message === void 0 ? 'Unknown server response' : _ref5$message, serverErrorCode = _ref5.code, serverErrorId = _ref5.id, serverTimestamp = _ref5.timestamp;
              _ref6 = request || {}, _ref6$responseURL = _ref6.responseURL, targetUrl = _ref6$responseURL === void 0 ? path : _ref6$responseURL;
              throw new HttpError(serverErrorId, method, targetUrl, status, serverMessage, serverErrorCode, serverTimestamp, _data);

            case 19:
              if (!request) {
                _context.next = 23;
                break;
              }

              throw new InternalError(1615822160971, 'No server response', {
                message: message || 'No error message.',
                name: name || 'No error name.'
              }, _context.t0);

            case 23:
              throw new InternalError(1615822160970, "Failed to execute request: ".concat(message, " - ").concat(String(_context.t0)), {
                message: message || 'No error message.',
                name: name || 'No error name.'
              }, _context.t0);

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 9]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
}

export { createRequest };